import React from 'react'

export const useElementOverflowing = ref => {
  const [state, setState] = React.useState(null)

  React.useEffect(() => {
    if (!ref.current) return

    setState(ref.current.scrollWidth > ref.current.clientWidth)
  }, [ref])

  return state
}
